import { useEffect, useState } from 'react';
import { Alert, Avatar, Box, Grid, LinearProgress, Paper, Snackbar, SnackbarCloseReason, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import * as yup from 'yup';

import { VTextField,  VForm, useVForm, IVFormErrors, VSwitch, VTextFieldPassword, VTextFieldNumber  } from '../../../shared/forms';
import { FerramentasDeDetalhe } from '../../../shared/components';
import { LayoutBaseDePagina } from '../../../shared/layouts';
import NavTabsUsuario from './NavTabsUsuario';
import { Environment } from '../../../shared/environment';
import { UsuarioService } from '../../../shared/services/api/UsuariosService';


interface IFormData {
  usuario: string;
  senha: string; 
  status: boolean;
  nivel: boolean;
}

interface IFormDataUpdate {
  status: boolean;
  nivel: boolean;
}

const formValidationSchema: yup.ObjectSchema<Omit<IFormData, 'status'>> = yup.object().shape({
  usuario: yup.string().required().min(5),
  senha: yup.string().required().min(8),
  nivel: yup.boolean().required(),
});

const formValidationSchema1: yup.ObjectSchema<IFormDataUpdate> = yup.object().shape({
  status: yup.boolean().optional().default(true),
  nivel: yup.boolean().required(),
});

export const DetalheUsuario: React.FC = () => {
  const navigate = useNavigate();
  const { id = 'novo' } = useParams<'id'>();
  const { formRef,  saveAndClose, save,  isSaveAndClose  } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const [nome, setNome] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  

  const [openConfirm, setOpenConfirm] = useState(false);
  
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if(tms === 'success'){ 
      navigate('/usuarios');
    }
  };

  useEffect(() => {
    if (id !== 'novo') {
      setIsLoading(true);
      UsuarioService.getById(id)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setNome(result.nome);
            formRef.current?.setData(result);
          }
        });
    } else {
      formRef.current?.setData({
        usuario: '',
        senha: '',
        status: true,
        nivel: false,
      });
    }
  }, [id]);

  const handleSave = (dados: IFormData) => {
    if (id === 'novo') {
      formValidationSchema.
        validate(dados, { abortEarly: false })
        .then((dadosValidados) => {
          setIsLoading(true);
          UsuarioService
            .create(dadosValidados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento Realizado com sucesso!');
                setOpenmsg(true);
              }
            });
        })
        .catch((errors: yup.ValidationError) => {
          const validationErrors: IVFormErrors = {};
          errors.inner.forEach(error => {
            if (!error.path) return;
            validationErrors[error.path] = error.message;
          });
          formRef.current?.setErrors(validationErrors);
        });
    }else{
      const updatedados = {
        status: dados.status,
        nivel: dados.nivel, 
      };
      formValidationSchema1.
        validate(updatedados, { abortEarly: false })
        .then((dadosValidados) => {
          setIsLoading(true);
          UsuarioService
            .updateById(id, dadosValidados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                setTms('error');
                setMsg(result.message);
                setOpenmsg(true);
              } else {
                setTms('success');
                setMsg('Lançamento Realizado com sucesso!');
                setOpenmsg(true);
              }
            });
        })
        .catch((errors: yup.ValidationError) => {
          const validationErrors: IVFormErrors = {};
          console.log(validationErrors);
          errors.inner.forEach(error => {
            if (!error.path) return;
            validationErrors[error.path] = error.message;
            setTms('error');
            setMsg(error.message);
            setOpenmsg(true);
          });
          formRef.current?.setErrors(validationErrors);
        });
    }
  };

  return (
    <LayoutBaseDePagina
      titulo={nome}
      barraDeFerramentas={
        <FerramentasDeDetalhe
          mostrarBotaoSalvarEFechar={false}
          mostrarBotaoImpressao={false}
          mostrarBotaoSalvar={true}
          mostrarBotaoSalvarCarregando = {isLoading}
          mostrarBotaoSalvarEFecharCarregando = {isLoading}
          mostrarBotaoNovo={false}
          mostrarBotaoApagar={false}
          aoClicarEmSalvar={save}
          aoClicarEmSalvarEFechar={saveAndClose}
          mostrarBotaoApagarCarregando = {isLoading}
          aoClicarEmVoltar={() => navigate('/usuarios')}
          mostrarBotaoVoltarCarregando = {isLoading}
        />
      }
    >
       <VForm ref={formRef} onSubmit={handleSave} placeholder=''onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
        <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
          <Alert
            onClose={handleCloseMsg}
            severity={tms}
            variant="filled"
            sx={{ width: '100%' }}
          >
            {msg}
          </Alert>
        </Snackbar>
        <Box margin={1} display="flex" alignItems='center'  flexDirection="column" component={Paper} variant="outlined">
          <Grid container direction="column"  padding={1} spacing={1}>
            {isLoading && (
              <Grid item>
                <LinearProgress variant='indeterminate' />
              </Grid>
            )}

            {(id != 'novo') && (
              <NavTabsUsuario
                id={id}
                nome={nome}
                case={0}                
              />
            )}
            <Grid item>
              <Typography variant='h6'>Dados do Cadastro</Typography>
            </Grid>
              <Grid item xs={12} sm={12} md={9} lg={6} xl={6}>
                <Grid container item direction="row" spacing={2}> 
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='usuario'
                      label='Login'
                      disabled={id === 'novo' ? false : true || isLoading}
                    />
                  </Grid>
                  {(id === 'novo') && (
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <VTextFieldPassword
                        fullWidth
                        size='small'
                        name='senha'
                        label='Senha'
                        isDisabled={isLoading}
                      />
                    </Grid>
                  )}
                  {(id != 'novo') && (
                    <Grid item xs={12} sm={12} md={6} lg={1} xl={1}>
                      <VSwitch
                        size='small'
                        name='status'
                        label='Status'
                        fdisabled={isLoading}
                      />
                    </Grid>
                  )}
                   <Grid item xs={12} sm={12} md={6} lg={1} xl={1}>
                      <VSwitch
                        size='small'
                        name='nivel'
                        label='Nivel'
                        fdisabled={isLoading}
                      />
                    </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </VForm> 
    </LayoutBaseDePagina>
  );
};